import multiRequest from '../shared/multiRequest';

const getData = account => {
  const queryAccount =
    account === undefined || account === null ? '' : `&account=${account}`;
  return multiRequest([
    {
      url: `invoices/last?months=6${queryAccount}`,
      method: 'GET',
    },
  ]);
};

const getInvoiceById = (accountId, documentId) => {
  return multiRequest([
    {
      url: `invoices/${accountId}/${documentId}/details`,
      method: 'GET',
    },
  ]);
};

const getInvoiceStatus = ({ flush = false, account = null } = {}) => {
  const path = [
    'invoices/debt-status',
    flush ? '?flush=true' : '',
    flush && account ? '&' : '',
    account ? `?account=${account}` : '',
  ];
  const debtUrl = path.join('');
  return multiRequest([
    {
      url: debtUrl,
      method: 'GET',
    },
  ]);
};

const getInvoiceStatusDetail = ({
  flush = false,
  account = null,
  months = 6,
} = {}) => {
  const path = [
    'invoices/v2/debt-status',
    flush ? '?flush=true' : '',
    flush && account ? '&' : '',
    account ? `?account=${account}` : '',
    months ? `${flush || account ? '&' : '?'}months=${months}` : '',
  ];
  const debtUrl = path.join('');
  return multiRequest([
    {
      url: debtUrl,
      method: 'GET',
    },
  ]);
};

const InvoicesServices = {
  getData,
  getInvoiceById,
  getInvoiceStatus,
  getInvoiceStatusDetail,
};

export default InvoicesServices;
